import React, { useCallback } from 'react';
import Header from 'src/routes/Layout/Header';
import { Container } from 'src/routes/Layout/Page/styles';
import fleetsService from 'src/service/fleetsService';
import { Content, LocalHeader, Title } from '../ReservationReport/styles';
import DataGrid from './components/DataGrid';
import usePaginationObservable from 'src/hooks/usePagination';
import Refresh from '../ReservationReport/components/Refresh';
import Filters from './components/Filters';

const Fleets = () => {
  const [params, mergeParams, loading, data, error, , refresh] = usePaginationObservable(
    params => fleetsService.listOrders(params),
    {
      orderBy: 'orderId',
      orderDirection: 'asc'
    },
    []
  );
  
  const handleRefresh = useCallback(async () => {
    try {
      refresh();
      return Promise.resolve();
    } catch (err) {
      return Promise.reject(err);
    }
  }, [refresh]);

  return (
    <Container>
      <Header 

      />
      <Content>
        <LocalHeader>
          <Title>Frotas</Title>
          <Refresh onClick={handleRefresh} loading={loading} />
        </LocalHeader>
        <Filters params={params} mergeParams={mergeParams} />
        <DataGrid
          params={params}
          mergeParams={mergeParams}
          loading={loading}
          error={error}
          data={data}
        />
      </Content>
    </Container>
  );
};

export default Fleets;
